/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';
import {
  ERROR_CHALLENGE_DEPOSIT_VERIFICATION,
  ERROR_REINITIATE_CHALLENGE_DEPOSITS
} from '../linkedBankAccounts/LinkedBankAccountsActions';

const FailedChallengeDepositsLogic = createLogic({
  type: [
    ERROR_REINITIATE_CHALLENGE_DEPOSITS,
    ERROR_CHALLENGE_DEPOSIT_VERIFICATION
  ],
  process({ action }, dispatch, done) {
    // dispatch user message
    const message =
      'There was an error performing a portion of the challenge deposit process.';
    dispatch(addToast(false, 'Error in challenge deposits', message));

    // dispatch analytics message
    dispatch(analyticsActionError(action.type));

    done();
  }
});

export default FailedChallengeDepositsLogic;
